export default "__VITE_ASSET__HG4wUVsY__"